import React from 'react';
import {reduxForm} from 'redux-form';
import {defineMessages, FormattedMessage} from 'react-intl';
import RecoverFormValidation from './PasswordRecoveryViaPhoneValidation.js';

import {stripProps} from 'shared/stripCorrectProps';

const messages = defineMessages({
    profile_code_label: {
        id: 'join.fast.phone_confirm.confirmation_code',
        defaultMessage: 'Код подтверждения'
    },
    profile_password_form_new_password_label: {
        id: 'create-password.profile_password_form_new_password_label',
        defaultMessage: 'Новый пароль'
    },
    profile_password_form_retype_password: {
        id: 'create-password.profile_password_form_retype_password',
        defaultMessage: 'Повторите пароль'
    },
    profile_password_form_btn_msg: {
        id: 'create-password.profile_password_form_btn_msg',
        defaultMessage: 'Сохранить'
    }
});

const SUCCESSFUL_UPDATE_REQUEST = 0;

export const fields = ['Code', 'NewPassword', 'NewPasswordConfirm'];

class PasswordRecoverViaPhone extends React.Component {
    static propTypes = {
        fields: React.PropTypes.any,
        handleSubmit: React.PropTypes.any,
        resetForm: React.PropTypes.any,
        submitAction: React.PropTypes.func.isRequired,
        isUpdating: React.PropTypes.any,
        isUpdated: React.PropTypes.any
    };

    static _renderError(error) {
        return (
            <div style={{marginLeft: '170px', color: '#9e2929'}}>
                <FormattedMessage {...error} />
            </div>
        );
    }

    constructor(props) {
        super(props);
        this.state = {requestSent: false, successfulRequest: false};
        this._onSubmit = this._onSubmit.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.isUpdating && !newProps.isUpdating) {
            this.setState({requestSent: true});
        } else {
            this.setState({requestSent: false});
        }
    }

    componentDidUpdate() {
        if (this.state.requestSent && this.props.isUpdated == SUCCESSFUL_UPDATE_REQUEST) {
            this.props.resetForm();
        }
    }

    _onSubmit(values) {
        this.props.submitAction(values);
    }

    render() {
        const {fields: {NewPassword, NewPasswordConfirm, Code}, handleSubmit} = this.props;
        const submitHandler = this._onSubmit;

        const formClass = 'settings--form settings--form__password-change form';
        const cleanClass = 'profile--form__row form__row';
        const errorClass = 'profile--form__row form__row form__row__error';
        const labelClass = 'settings--form__label form__label';
        const inputClass = 'settings--form__control form__control';
        const btnClass = 'withdrawal--form__btn withdrawal-bid--form__btn__js form__btn';

        return (
            <form className={formClass} onSubmit={handleSubmit(submitHandler)}>
                <input style={{display:'none'}} type="password" name="fakepasswordremembered" />

                {Code.touched && Code.error &&
                <div className={errorClass}>
                    <label className={labelClass}>
                        <FormattedMessage {...messages.profile_code_label} />
                    </label>
                    <input type="text" className={inputClass} {...stripProps(Code)} />
                    {PasswordRecoverViaPhone._renderError(Code.error)}
                </div>}
                {(!Code.touched || !Code.error) &&
                <div className={cleanClass}>
                    <label className={labelClass}>
                        <FormattedMessage {...messages.profile_code_label} />
                    </label>
                    <input type="text" className={inputClass} {...stripProps(Code)} />
                </div>}

                {NewPassword.touched && NewPassword.error &&
                <div className={errorClass}>
                    <label className={labelClass}>
                        <FormattedMessage {...messages.profile_password_form_new_password_label} />
                    </label>
                    <input type="password" className={inputClass} {...stripProps(NewPassword)} />
                    {PasswordRecoverViaPhone._renderError(NewPassword.error)}
                </div>}
                {(!NewPassword.touched || !NewPassword.error) &&
                <div className={cleanClass}>
                    <label className={labelClass}>
                        <FormattedMessage {...messages.profile_password_form_new_password_label} />
                    </label>
                    <input type="password" className={inputClass} {...stripProps(NewPassword)} />
                </div>}

                {NewPasswordConfirm.touched && NewPasswordConfirm.error &&
                <div className={errorClass}>
                    <label className={labelClass}>
                        <FormattedMessage {...messages.profile_password_form_retype_password} />
                    </label>
                    <input type="password" className={inputClass} {...stripProps(NewPasswordConfirm)} />
                    {PasswordRecoverViaPhone._renderError(NewPasswordConfirm.error)}
                </div>}
                {(!NewPasswordConfirm.touched || !NewPasswordConfirm.error) &&
                <div className={cleanClass}>
                    <label className={labelClass}>
                        <FormattedMessage {...messages.profile_password_form_retype_password} />
                    </label>
                    <input type="password" className={inputClass} {...stripProps(NewPasswordConfirm)} />
                </div>}

                <div className="settings--form__row form__row">
                    <button type="submit" className={btnClass} onClick={handleSubmit(submitHandler)}>
                        <FormattedMessage {...messages.profile_password_form_btn_msg} />
                    </button>
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'phone-password-recovery',
    fields: fields,
    initialValues: {},
    validate: RecoverFormValidation
})(PasswordRecoverViaPhone);


// WEBPACK FOOTER //
// ./js/sport-betting/components/PasswordRecoverViaPhone.jsx